<!-- DropZoneImage.vue -->
<template>
  <div class="dropzone-container rounded p-2" :style="{ height: height + 'px', width: width + 'px' }"
       v-bind="getRootProps()">
    <input v-bind="getInputProps()"/>
    <p v-if="isDragActive">Drop the files here ...</p>
    <p v-else-if="displayText">{{ text }}</p>

    <ul v-if="modelValue.length" class="file-list d-flex flex-wrap">
      <li v-for="(file, index) in modelValue" :key="index" class="mt-2">
        <img
            class="preview-image-large"
            v-if="file.type.startsWith('image/')"
            :src="getPreview(file)"
            alt="Uploaded Image"
        /><br/>
        {{ file.name }} ({{ formatSize(file.size) }})
      </li>
    </ul>
  </div>
</template>

<script setup>
import {computed, defineEmits, defineProps, onBeforeUnmount, toRefs} from 'vue';
import {useDropzone} from 'vue3-dropzone';

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  multiple: {
    type: Boolean,
    default: true,
  },
  text: {
    type: String,
    default: 'Ziehen Sie einige Dateien per Drag & Drop hierher, oder klicken Sie zum Auswählen',
  },
  height: {
    type: [String, Number],
    default: 200,
  },
  width: {
    type: [String, Number],
    default: 350,
  },
});

const modelValue = toRefs(props).modelValue;
const emit = defineEmits(['update:modelValue']);
const displayText = computed(() => !modelValue.value.length);

const onDrop = (acceptedFiles) => {
  emit('update:modelValue', acceptedFiles);
};

const {getRootProps, getInputProps, isDragActive} = useDropzone({
  onDrop,
  multiple: props.multiple,
});

// Generiše preview URL za slike
const getPreview = (file) => {
  return URL.createObjectURL(file);
};

// Formatiranje veličine fajla
const formatSize = (size) => {
  return size < 1024
      ? `${size} B`
      : size < 1024 * 1024
          ? `${(size / 1024).toFixed(1)} KB`
          : `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

// Cleanup URL-ova kada komponenta bude uništena
onBeforeUnmount(() => {
  modelValue.value.forEach(file => {
    if (file && file.type.startsWith('image/')) {
      URL.revokeObjectURL(file);
    }
  });
});
</script>

<style scoped>
.dropzone-container {
  border: 2px dashed #ccc;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: background 0.3s;
}

.dropzone-container:hover {
  background-color: #f1f1f1;
}

.file-list {
  gap: 24px;
  margin-top: 5px;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}

.file-list li {
  width: 230px;
  height: 160px;
  overflow: hidden;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-image-large {
  max-width: 100%;
  max-height: 160px;
  object-fit: contain;
}
</style>